import styled from "styled-components";

import { fontSizes } from "../../../shared/styles/typography";

export const Body = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding-bottom: 40px;
`;

export const IntroCard = styled.div`
  background: var(--color-surface, #fff);
  border-radius: 16px;
  border: 1px solid var(--color-border, #e8eaf0);
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const IntroTitle = styled.h2`
  margin: 0;
  font-size: ${fontSizes.xl}px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-title, #1e293b);
`;

export const IntroSubtitle = styled.p`
  margin: 0;
  font-size: ${fontSizes.sm}px;
  line-height: 1.45;
  color: var(--color-text-secondary, #64748b);
`;

export const CategoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
`;

export const CategoryCard = styled.button<{ $accent: string }>`
  min-height: 112px;
  border-radius: 16px;
  border: 1px solid var(--color-border, #e8eaf0);
  border-left: 4px solid ${({ $accent }) => $accent};
  background: var(--color-surface, #fff);
  padding: 16px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 12px;
  text-align: left;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.12s ease;

  &:hover {
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.08);
  }

  &:active {
    transform: scale(0.98);
  }
`;

export const CategoryIconBox = styled.div<{ $accent: string }>`
  width: 40px;
  height: 40px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ $accent }) => `${$accent}22`};
  color: ${({ $accent }) => $accent};
`;

export const CategoryTitle = styled.h3`
  margin: 0 0 2px;
  font-size: ${fontSizes.base}px;
  font-weight: var(--font-weight-semibold);
  color: var(--color-text-title, #1e293b);
`;

export const CategoryHint = styled.span`
  font-size: ${fontSizes.sm}px;
  color: var(--color-text-secondary, #64748b);
`;
